import { styled } from "@mui/material/styles";
import Switch, { SwitchProps } from "@mui/material/Switch";
import { useEffect, useState } from "react";

interface CustomSwitchProps {
  checked: boolean;
  onSwitch?: () => void;
  disabled?: boolean;
}

const CustomSwitch: React.FC<CustomSwitchProps> = ({
  checked,
  onSwitch,
  disabled,
}) => {
  const [isChecked, setIsChecked] = useState<boolean>(checked);

  useEffect(() => {
    setIsChecked(checked);
  }, [checked]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsChecked(event.target.checked);
    if (onSwitch) onSwitch();
  };

  return (
    <CustomSwitchPattern
      sx={{ m: 1 }}
      checked={isChecked}
      onChange={handleChange}
      disabled={disabled}
    />
  );
};

const CustomSwitchPattern = styled((props: SwitchProps) => (
  <Switch
    focusVisibleClassName='.Mui-focusVisible'
    disableRipple
    disableFocusRipple
    disableTouchRipple
    {...props}
  />
))(({ theme }) => ({
  "& .MuiSwitch-thumb": {
    boxShadow: "0px 0.3px 2.5px rgba(0, 0, 0, 0.4)",
  },
  "& .MuiSwitch-switchBase": {
    transitionDuration: "300ms",
    "&.Mui-checked": {
      color: theme.palette.natural.t4,
      "& + .MuiSwitch-track": {
        backgroundColor: theme.palette.main.primary.o,
        opacity: 1,
        border: 0,
      },
    },
    "&.Mui-checked:hover, &.MuiSwitch-switchBase:hover": {
      backgroundColor: "transparent",
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: theme.palette.main.primary.o,
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      color:
        theme.palette.mode === "light"
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
  },
  "& .MuiSwitch-track": {
    backgroundColor: theme.palette.mode === "light" ? "#E9E9EA" : "#39393D",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
  },
}));

export default CustomSwitch;
